import { render, staticRenderFns } from "./StudentPasswordField.vue?vue&type=template&id=4a228ddf&scoped=true&"
import script from "./StudentPasswordField.vue?vue&type=script&lang=js&"
export * from "./StudentPasswordField.vue?vue&type=script&lang=js&"
import style0 from "./StudentPasswordField.vue?vue&type=style&index=0&id=4a228ddf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a228ddf",
  null
  
)

export default component.exports